module.exports = __webpack_public_path__ + "static/media/texture-wood-grey.610051b4.jpg";